import { apiGet } from '../shared/utils/apiClient'
import { API_CONFIG } from './config/api'

export interface BoxCollection {
  address: string
  version: number
  status: number
  createdAt: string
  updatedAt: string
}

export async function getActiveBoxCollections(): Promise<BoxCollection[]> {
  // Protected endpoint - requires authentication
  const response = await apiGet(API_CONFIG.endpoints.boxCollections.getActive)

  if (!response.ok) {
    throw new Error(
      `Failed to fetch active box collections: ${response.status} ${response.statusText}`,
    )
  }

  return response.json()
}
